import React from "react";
import { Link } from "react-router-dom";
import { companyConfig } from "@/config/companyConfig";

// Mandatory logo rule: render ONLY the logo image. Never add the word "Captec" beside it.
export const Logo = ({ className = "", height = 32, variant = "light", to = "/", dataTestid }) => {
  // Use the existing white asset on dark headers; preserve the original brand asset elsewhere.
  return (
    <Link to={to} aria-label="Captec - Inicio" data-testid={dataTestid} className={`inline-flex items-center focus-ring rounded-md ${className}`}>
      <img
        src={variant === "white" ? "/assets/logos/captec-logo-white.png" : companyConfig.logoUrl}
        alt={companyConfig.logoAlt}
        style={{ height: `${height}px`, width: "auto", maxWidth: "200px" }}
        className="object-contain select-none"
        draggable={false}
      />
    </Link>
  );
};

export default Logo;
